import api from "./axiosInstance";

/**
 * Get users list
 * @param {number} limit
 * @param {number} offset
 */
export const getUsers = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/account/users/?limit=${limit}&offset=${offset}/`
  );
  return response.data;

};

export const createUser = async (payload) => {
  const response = await api.post(
    "api/v1/account/users/",
    payload
  );
  return response.data;
};

export const updateUser = async (userId, payload) => {
  const response = await api.patch(
    `api/v1/account/users/${userId}/`,
    payload
  );
  return response.data;
};


export const deleteUser = async (userId) => {
  await api.delete(`api/v1/account/users/${userId}/`);
};

